export default {
    errors: {
        order_already_returned: "Order already returned",
        no_orders: "Order not found",
        db_query_failed: "Database Error",
        db_fetch_failed: "Database Error",
        permission_denied: "Access Denied",
        invalid_param: "Invalid Parameter",
        internal: "Server Error",
        payment_method_not_found: "Payment method not found",
        inventory_not_found: "Product not exist in Inventory",
		orders:{
			not_found:"Order not found",
			map_product:"Product not sync to inventory",
			invalid_date_range: "Daterange can't over 31 day",
		},
        user: {
            duplicate: "Duplicate User information",
            duplicate_username: "Duplicate Username information",
            duplicate_email: "Duplicate email information",
            blcok_delete_by_self: "Can't delete data by yourself.",
            fail: "Error update user information",
            email_wrong_format: "Wrong email format"
        },
        auth: {
            login_fail: "Login Fail",
            block: "User has been blocked",
            login_success: "Login Success",
            logout_success: "Log out Success",
            unauthoriezed: "No permission",
            reset_invalid_token: "token invalid",
            reset_token_expired: "token reset_token_expired",
            forgot_password_fail: "forgot password failed",
            reset_password_fail: "reset password failed",
            username_wrong_format: "Wrong username format",
            password_wrong_format: "Wrong password format",
            token: "Invalid Token",
            password: "Invalid password",
            password_confirm: "Invalid confirm password"
        },
        profile: {
            change_profile_failed: "Change profile failed",
            change_password_failed: "Change password failed",
            password_confirm_not_match: "Error confirm password",
            password_confirm_wrong_format: "Wrogn password format.",
            password_old_wrong: "Wrong old password"
        },
        wms: {
            inventory_create_fails: "Create inventory failed",
            inventory: {
                balance_not_enough: "Product not enought"
            }
        },
        wh: {},
        packing: {
            invalid_order_status: "Invalid Order Status",
            goods_is_added: "Goods already added"
        }
    },
    bc_user: "User",
    bc_change_profile: "User information",
    bc_change_password: "Change password",
    bc_admin: "Admin",
    bc_platform_connect: "Platform Connect",

    profile: {
        profile: "Profile",
        info: "UserInfomation",
        name: "Name",
        lname: "Surname",
        phone: "Phone",
        email: "E-Mail",
        change_password: "Change Password",
        password_old: "Old Password",
        password_new: "New Password",
        password_confirm: "Confirm Password",
        change_profile_success: "Change profile successed",
        change_password_success: "Change password successed"
    },
    menu: {
        user: "User",
        member: "Member",
        admin: "Administrator",
        admin_product: "Product and promotion",
        admin_platform_connect: "Platform Connect",
        sale_channel: "Sale Channel",
        product: "Product",
        team: "Team",
        order_status: "Status"
    },
    auth: {
        unverify: "User not verfy",
        block: "User has been blocked",
        signin: "Signin",
        signout: "Signout",
        username: "Username",
        email: "E-Mail",
        password: "Password",
        forgetpassword: "Forgot Password",
        resetpassword: "Reset Password",
        confirm_reset_password: "Confirm reset password ",
        forgot_password_success: "Forgot password successfully",
        reset_password_success: "Reset password successfully"
    },

    user: {
		create: "Create User",
		name: "Name",
		username: "Username",
		type: "Type",
		phone: "Phone",
		role: "Role",
		create_success: "Create User successed",
		create_fail: "Create User failed"
    },
    name: "Name",
    description: "Description",
    location_x: "Location (X)",
    location_y: "Location (Y)",
    group_name: "Group name",
    email: "E-Mail",
    email_optional: "E-Mail (Optional)",
    created: "Create Date",
    payment_at: "Payment Date",
    search: "Search",
    save: "Save",
    back: "Back",
    new: "New",
    status: "Status",
    download: "Download",
    downloadall: "Download All",
    product_search: "Product Search",
    welcome: "Welcome",
    myprofile: "Profile",
    changepassword: "Change Password",
	page_notfound: "Sorry Page not found.",
	page_notfound_desc: "Plase check URL again.",
	actions: "Action",
    data: "Data",
    to: "To",
    of: "From",
    row_select: "Selected",
    yes: "Yes",
    no: "No",
    ok: "Ok",
    cancel: "Cancel",
    confirm_cancel: "Confrim Cancel",
    upload_file: "Upload file",
    add: "Add",
    close: "Close",
    please_select: "Please select",
    please_select_payment_method_type: "Please select payment method",
    please_select_sale_channel_type: "Please select sale channel",
    please_select_shipping_provider_type: "Please select shipping provider",
	create: "Create",
	confirm: "Confirm",
	create_success: "Create success",
	delete_confirm: "Confirm delete",
	delete_confirm_text: "Please confirm delete ",
	delete_confirm_question: "Do you want to delete this information ? ",
	delete_success: "Delete successed",
	delete_fail: "Delete Failed",
	edit_success: "Editing successed",
	edit_fail: "Editing failed",
    update_success: "Updating successed",
    update_fail: "Updating failed",

    // Inventory
    inventory_transfer: "Pickup from Main",
    inventory_transfer_to_line: "Pickup to Line",
    inventory_out: "Out",
    inventory_in: "In",
    phone: "Phone",

    // =================================================================
    // WMS Module
    // =================================================================
    wms: {
        name: "Inventory System",
        menu: {
            inventory_dashboard: "Dashboard",
            inventory: "Inventory",
            inventory_list: "Inventory List",
            inventory_list_detail: "Inventory List By Stock",
            inventory_history: "Inventory History",
			inventory_history_product_list: "Product History",
			inventory_history_storage_list: "Storage History",
            inventory_summary_packing: "Packing Summary",
            partner: "Partner",
            product: "Product",
            storage: "Storage",
            promotion: "Promotion"
        },

        created_at: "Date",
        staff: "Staff",
        bill_number: "Bill Number",
        bill_image: "Bill Image",

        inventory_main: "Main Inventory",
        inventory_src: "Source",
        inventory_dst: "Destination",
        inventoryin_list: "In",
        inventoryout_list: "Out",
        inventorytransfer_list: "Transfer",
        // Prodcut
        product_name: "Product Name",
        partner: "Partner",
        package_name: "Unit name",
        barcode: "Barcode",
        product_width: "Width",
        product_height: "Height",
        product_depth: "Depth",
        product_weight: "Weight",
        product_pn: "SKU",

        // Partner
        company_name: "Company Name",
        address: "Address",
        contact_name: "Contact",
        contact_tel: "Telephone",

        // Inventory
        inventory_in: "In",
        inventory_out: "Out",

        amount: "Amount",
        cost: "Cost",
        note: "Note",
        product: "Product",
        corporate: "Corporate",
        storage: "Storage",
        balance: "Balance",
        overall_amount: "Overall Amount",
        overall_cost: "Overall Cost",
        taxid: "TAX ID",
        tel: "Phone",
        email: "E-Mail",
        storage_name: "Storage Name",
        storage_desc: "Storage Description",
        x: "X",
        y: "Y",

        width: "Width (cm)",
        height: "Height (cm)",
        depth: "Depth (cm)",
        weight: "Weight (g)"
    },

    // =================================================================
    // Backoffice Module
    // =================================================================

    backoffice: "Backoffice",
    orders: "Orders",
    products: "Product",
    packings: "Packing",
    order_return: "Return",
    payments: "Payment",
    reports: "Report",
    customer_information: "Customer Information",
    customer: "Customer",
    platform_connect: "Platform Connect",
    product_information: "Product Information",
    seller_note: "Seller Note",
    order_form: "New Order",
    order_status: "Status",
    order_number: "Order Number",
    order_user: "Staff",
    order_detail: "Order Detail",
    order_form: "New Order",
    order_count: "Order Count",


    order_status_unpaid: "Unpaid",
    order_status_awaiting_shipment: "Awaiting Shipment",
    order_status_awaitingcollection: "Awaiting Collection",
    order_status_partiallyshipping: "Partially Shipping:",
    order_status_intransit: "Intransit",
    order_status_delivered: "Delivered",
    order_status_completed: "Completed",
    order_status_cancelled: "Cancelled",
    order_status_returned: "Returned",
    order_status_claimed: "Claimed",
    order_status_returning : "Returning (Platform)",
    order_status_intransit_completed : "Intransit, Completed",

    payment_slip: "Payment SLIP",
    payment_channel: "Payment Channel",
    payment_method: "Payment Channel",
    payment_check: "Payment Check",

    platform: "Platform",
    sale_channel: "Sale Channel",
    sale_channel_type: "Sale channel type",
    recipient_name: "Name",
    recipent_address: "Address",
    recipent_district: "District",
    recipent_city: "City",
    recipent_province: "Province",
    recipent_zipcode: "Zipcode",
    recipient_phone: "Phone",

    report_by_team: "Report By Team",
    report_by_sale_channel: "Report By SaleChannel",
    report_by_user: "Report By Staff",
    report_by_product: "Report By Prodcut",
    report_by_user_product: "Report By Staff And Product",

    time_from: "Start",
    time_to: "End",
    all: "All",
    type: "Type",
    bank: "Bank",
    bank_account: "Account Number",
    bank_branch: "Branch",
    detail: "Detail",
    product: "Product",
    price: "Procie",
    image: "Image",
    tag: "Tags",
    quantity: "Quantity",
    product_form: "Product Manage",
    product_code: "Product Code",
    product_category: "Product Category",
    is_comboset: "Is Comboset",
    team: "Team",
    department: "Department",
    fname: "Name",
    lname: "Lastname",
    nick_name: "Nickname",
    password_old: "Old password",
    password: "Password",
    password_confirm: "Confirm Password",
    password_not_match: "Password not match",
    packing_number: "Packing Number",
    packing_user: "Packing Staff",
    packing_date: "Packing Date",
    line_packing: "Line Packing",
    please_select_sale_channel: "Please select sale channel",
    please_select_payment_method: "Please select payment channel",
    payment_success: "Payment success",
    payment_fail: "Payment fail",
    shipping: "Shipping",
    shipping_provider: "Shipping Provider",
    barcode: "Barcode",
    scanbarcode: "Click to scan Barcode",
    product_pn: "Product Code",
    tracking_number: "Tracking Number",
    order_information: "Order Information",
    product_image: "Product Image",
    product_name: "Product Name",
    product_pickup: "Quantity",
    cancel_confirm: "Confirm cancel",
    cancel_confirm_question: "Cancel order ",
    cancel_order_success: "Cancel order success",
    please_select_cancel_reason: "Please select cancel reason",
    please_input_cancel_reason: "Plase input cancel reason",

    shipping_return: "Shipping Return",

    user_group: "User Group",

    // Report
    order_amount: "Order Amount",
    payment_amount: "Payment Amount",
    payment_amount_net: "Summary",
    product_amount: "Product Amount",
    discount: "Discount",
    payment_method_type: "Payment method type",
    sort_type: "Sort type",
    change_tracking_success: "Change tracking success",
    change_shipping_success: "Change shipping success",
	price_per_unit:"Price per unit",
    member: {
        line_user_id: "LINE User ID",
        birthday: "Birthday",
        sex: "Gender",
        total_spending: "Total Spending",
        address: "Address",
        province: "Province",
        district: "District",
        subdistrict: "Subdistrict",
        postcode: "Postcode",
        coupons: "Coupons",
        coupon_code: "Coupon Code",
        coupon_status: "Status",
        used: "Used",
        unused: "Unused",
        created_at: "Created",
        used_at: "Used At",
        no_coupons: "No coupons found",
        error_loading_coupons: "Error loading coupons"
    },
    webcam_recording: "Webcam Recording",
    waiting_for_packaging: "Waiting for Packaging",
    camera_settings: "Camera Settings",
    select_camera: "Select Camera",
    connect_camera: "Connect Camera",
    camera_connected: "Camera Connected",
    camera_disconnected: "Camera Disconnected",
    preview_webcam: "Preview Webcam",
    hide_preview: "Hide Preview",
    no_camera_found: "No camera found",
    unable_to_access_camera: "Unable to access camera",
    scanning_barcode: "Scanning Barcode...",
    barcode_scanned: "Barcode Scanned",
    add_product_success: "Product added successfully",
    product_not_found: "Product not found in order",
    all_items_packed: "All items packed. You can complete the order.",
    packing_complete: "Packing Complete",
    complete_order: "Complete Order",
    confirm_complete_order: "Are you sure you want to complete this order?",
    order_completed_success: "Order marked as completed successfully",
    order_completed_fail: "Failed to mark order as completed",
    return_to_packaging: "Return to Packaging",
    camera_device: "Camera Device",
    video_quality: "Video Quality",

    // =================================================================
    // Platform Statement Module
    // =================================================================
    platform_statement: {
        name: "Platform Statement",
        menu: "Platform Statement",
        list: "Statement List",
        upload: "Upload Statement",
        detail: "Statement Detail",
        summary: "Summary Report",

        statement_number: "Statement Number",
        statement_date: "Statement Date",
        settlement_date: "Settlement Date",
        platform: "Platform",
        platform_shop_id: "Shop ID",

        total_orders: "Total Orders",
        total_sales_amount: "Total Sales",
        total_platform_fee: "Platform Fee",
        total_commission: "Commission",
        total_shipping_fee: "Shipping Fee",
        total_other_fee: "Other Fees",
        net_amount: "Net Amount",

        platform_order_id: "Platform Order ID",
        related_order_id: "Related Order ID",
        order_date: "Order Date",
        order_created_time: "Order Created Time",
        order_settled_time: "Order Settled Time",
        transaction_type: "Transaction Type",
        currency: "Currency",
        order_amount: "Order Amount",
        total_revenue: "Total Revenue",

        // Seller Discounts
        subtotal_after_seller_discounts: "Subtotal After Seller Discounts",
        subtotal_before_discounts: "Subtotal Before Discounts",
        seller_discounts: "Seller Discounts",

        // Refunds
        refund_subtotal_after_seller_discounts: "Refund Subtotal After Seller Discounts",
        refund_subtotal_before_seller_discounts: "Refund Subtotal Before Seller Discounts",
        refund_of_seller_discounts: "Refund of Seller Discounts",

        // Fees
        platform_fee: "Platform Fee",
        commission: "Commission",
        transaction_fee: "Transaction Fee",
        credit_card_installment_fee: "Credit Card Installment Fee",
        payment_fee: "Payment Fee",

        // Shipping
        shipping_fee: "Shipping Fee",
        seller_shipping_fee: "Seller Shipping Fee",
        actual_shipping_fee: "Actual Shipping Fee",
        platform_shipping_fee_discount: "Platform Shipping Fee Discount",
        customer_shipping_fee: "Customer Shipping Fee",
        refund_customer_shipping_fee: "Refund Customer Shipping Fee",
        actual_return_shipping_fee: "Actual Return Shipping Fee",
        shipping_fee_subsidy: "Shipping Fee Subsidy",
        seller_shipping_fee_discount: "Seller Shipping Fee Discount",

        // Affiliate
        affiliate_commission: "Affiliate Commission",
        affiliate_commission_before_pit: "Affiliate Commission Before PIT",
        personal_income_tax_withheld: "Personal Income Tax Withheld",
        affiliate_partner_commission: "Affiliate Partner Commission",
        affiliate_shop_ads_commission: "Affiliate Shop Ads Commission",
        affiliate_commission_deposit: "Affiliate Commission Deposit",
        affiliate_commission_refund: "Affiliate Commission Refund",

        // Service Fees
        sfp_service_fee: "SFP Service Fee",
        live_specials_service_fee: "Live Specials Service Fee",
        voucher_xtra_service_fee: "Voucher Xtra Service Fee",
        eams_program_service_fee: "EAMS Program Service Fee",
        brand_crazy_deals_flash_sale_fee: "Brand Crazy Deals Flash Sale Fee",
        bonus_cashback_service_fee: "Bonus Cashback Service Fee",
        tiktok_paylater_program_fee: "TikTok PayLater Program Fee",
        commerce_growth_fee: "Commerce Growth Fee",
        infrastructure_fee: "Infrastructure Fee",
        campaign_resource_fee: "Campaign Resource Fee",
        other_fee: "Other Fees",

        // Adjustment
        adjustment: "Adjustment",
        adjustment_amount: "Adjustment Amount",

        // Customer Payment
        customer_payment: "Customer Payment",
        customer_refund: "Customer Refund",

        // Vouchers
        seller_co_funded_voucher_discount: "Seller Co-Funded Voucher Discount",
        refund_of_seller_co_funded_voucher: "Refund of Seller Co-Funded Voucher",
        platform_discounts: "Platform Discounts",
        refund_of_platform_discounts: "Refund of Platform Discounts",
        platform_co_funded_voucher_discounts: "Platform Co-Funded Voucher Discounts",
        refund_of_platform_co_funded_voucher: "Refund of Platform Co-Funded Voucher",

        // Additional Info
        estimated_package_weight: "Estimated Package Weight",
        actual_package_weight: "Actual Package Weight",
        shopping_center_items: "Shopping Center Items",
        customer_bank_for_payment: "Customer Bank for Payment",
        product_name: "Product Name",
        quantity: "Quantity",
        sku: "SKU",

        upload_file: "Upload Excel File",
        select_platform: "Select Platform",
        drag_drop_file: "Drag & drop file here or click to browse",
        supported_formats: "Supported formats: .xlsx, .xls",
        max_file_size: "Maximum file size: 50MB",

        upload_success: "Statement uploaded successfully",
        upload_fail: "Failed to upload statement",
        delete_success: "Statement deleted successfully",
        delete_fail: "Failed to delete statement",
        delete_confirm: "Delete Statement",
        delete_confirm_text: "Are you sure you want to delete this statement?",

        export_excel: "Export Excel",
        export_pdf: "Export PDF",
        generate_report: "Generate Report",

        search_by_statement_number: "Search by Statement Number",
        filter_by_platform: "Filter by Platform",
        filter_by_date: "Filter by Date",

        uploaded_by: "Uploaded By",
        uploaded_at: "Uploaded At",
        uploaded_filename: "Uploaded File Name",

        financial_summary: "Financial Summary",
        order_details: "Order Details",

        type_order: "Order",
        type_refund: "Refund",
        type_adjustment: "Adjustment",

        all_platforms: "All Platforms",

        no_data: "No data found",
        loading: "Loading...",

        date_range: "Date Range",
        from_date: "From Date",
        to_date: "To Date",

        total_statements: "Total Statements",
        total_fees: "Total Fees",
        fee_percentage: "Fee Percentage",

        // Breakdown sections
        revenue_breakdown: "Revenue Breakdown",
        fee_breakdown: "Fee Breakdown",
        adjustment_breakdown: "Adjustment Breakdown",

        // Fee breakdown items
        total_transaction_fee: "Total Transaction Fee",
        total_affiliate_commission: "Total Affiliate Commission",
        total_affiliate_shop_ads: "Total Affiliate Shop Ads",
        total_service_fees: "Total Service Fees",

        // Adjustment breakdown items
        total_adjustment: "Total Adjustment",
        shipping_fee_adjustment: "Shipping Fee Adjustment",
        logistics_reimbursement: "Logistics Reimbursement",
        platform_compensation: "Platform Compensation",
        platform_penalty: "Platform Penalty",
        other_adjustments: "Other Adjustments",

        view_details: "View Details",
        back_to_list: "Back to List",
    }
};
